import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { formGroupPatchValueNullFriendly } from 'app/helpers/utils';
import { WorkflowAutoStart } from 'app/models/workflow-auto-start';
import { WorkflowFile } from 'app/models/workflow-file';
import { WorkflowForm } from 'app/models/workflow-form';
import { WorkflowTemplateService } from 'app/services/workflow-template.service';
import { WorkflowWizardService } from 'app/services/workflow-wizard.service';
import { AddEditAutoStartRuleComponent } from '../add-edit-auto-start-rule/add-edit-auto-start-rule.component';

@Component({
  selector: 'app-auto-start-rules',
  templateUrl: './auto-start-rules.component.html',
  styleUrls: ['./auto-start-rules.component.scss']
})
export class AutoStartRulesComponent implements OnInit {

  
  @Input() workflowStepCompletionFormGroup: FormGroup;
  @Input() isInitialStepCompletion: boolean = false;
  
  autoStarts: WorkflowAutoStart[] = [];

  allFiles: WorkflowFile[];
  allForms: WorkflowForm[];

  tableLimitSelect = [5, 10, 20, 30, 50, 100];
  selectedAutoStartTableLimit: number = 5;

  editRuleIndex: number = -1;

  @ViewChild('addEditAutoStartRule', { static: true }) addEditAutoStartRule: AddEditAutoStartRuleComponent;

  constructor(public workflowWizardService: WorkflowWizardService, private workflowTemplateService: WorkflowTemplateService) { }

  ngOnInit(): void {
    this.allForms = this.workflowTemplateService.getParentForms(this.workflowStepCompletionFormGroup.root as FormGroup, this.workflowStepCompletionFormGroup.value.name, 
      (this.workflowWizardService.currentStep && this.workflowWizardService.currentStep.value && this.workflowWizardService.currentStep.value.name)? 
        this.workflowWizardService.currentStep.value.name: null);

    this.allFiles = this.workflowTemplateService.getParentFiles(this.workflowStepCompletionFormGroup.root as FormGroup, this.workflowStepCompletionFormGroup.value.name, 
      (this.workflowWizardService.currentStep && this.workflowWizardService.currentStep.value && this.workflowWizardService.currentStep.value.name)? 
        this.workflowWizardService.currentStep.value.name: null);

      this.setAutoStartsList();
    this.workflowStepCompletionFormGroup.valueChanges.subscribe(() => {
      this.setAutoStartsList();      
    });
  }

  setAutoStartsList() {
    this.autoStarts = this.workflowStepCompletionFormGroup.value.auto_starts;
  }

  editAutoStartRule(autoStart: WorkflowAutoStart, index: number){
    this.editRuleIndex = index;
    let frmGroup: FormGroup = this.workflowTemplateService.getWorkflowAutoStartFormGroup(autoStart);
    formGroupPatchValueNullFriendly(frmGroup, autoStart);
    this.addEditAutoStartRule.show(frmGroup);
  }

  deleteAutoStartRule(autoStart: WorkflowAutoStart, index: number){
    let autoStartsFormArray: FormArray = (this.workflowStepCompletionFormGroup.controls['auto_starts'] as FormArray);
    autoStartsFormArray.removeAt(index);
  }

  onAddEditFinished(frm: FormGroup) {
    let autoStartsFormArray: FormArray = (this.workflowStepCompletionFormGroup.controls['auto_starts'] as FormArray);

    if (this.editRuleIndex != -1) {
      (<FormGroup>autoStartsFormArray.controls[this.editRuleIndex]).controls['files'] = frm.controls['files'];
      frm.get('files').setParent(<FormGroup>autoStartsFormArray.at(this.editRuleIndex));

      (<FormGroup>autoStartsFormArray.controls[this.editRuleIndex]).controls['forms'] = frm.controls['forms'];
      frm.get('forms').setParent(<FormGroup>autoStartsFormArray.at(this.editRuleIndex));

      formGroupPatchValueNullFriendly(autoStartsFormArray.at(this.editRuleIndex) as FormGroup, frm.value);
      this.editRuleIndex = -1;
    } else {
      autoStartsFormArray.push(frm);
      frm.setParent(autoStartsFormArray);
    }
  }
  
  onAddNewRule() {
    this.editRuleIndex = -1;
    let frmGroup: FormGroup = this.workflowTemplateService.getWorkflowAutoStartFormGroup({} as WorkflowAutoStart);
    this.addEditAutoStartRule.show(frmGroup);
  }
}
